import React from 'react'
import { useLoading } from '../../contexts/LoadingContext'

const GlobalLoadingOverlay = () => {
  const { isLoading } = useLoading()

  if (!isLoading) return null

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl px-6 py-4 flex items-center gap-4">
        <div className="animate-spin flex-shrink-0">
          <svg className="w-8 h-8 text-blue-600 dark:text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
        <span className="text-gray-700 dark:text-gray-200 font-medium">Aguarde...</span>
      </div>
    </div>
  )
}

export default GlobalLoadingOverlay
